export enum TagSortType {
    Id,
    Name,
    IsDeleted
}
